import { getToken } from '@/utils/auth';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

// API instance - Update baseURL to match your backend
const api = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});




// hər request-ə token əlavə et
api.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Subjects API
export const subjectsApi = {
  getAll: () => api.get('/api/subjects'),
  getOne: (id) => api.get(`/api/subjects/${id}`),
  create: (data) => api.post('/api/subjects', data),
  update: (id, data) => api.put(`/api/subjects/${id}`, data),
  delete: (id) => api.delete(`/api/subjects/${id}`),
};

// Topics API
export const topicsApi = {
  getBySubject: (subjectId) => api.get(`/api/topics/subjects/${subjectId}/topics`),
  create: (data) => api.post('/api/topics', data),
  update: (id, data) => api.put(`/api/topics/${id}`, data),
  delete: (id) => api.delete(`/api/topics/${id}`),
};

// Questions API
export const questionsApi = {
  getByTopic: (topicId) => api.get(`/api/questions/topicAdmin/${topicId}`),
  getOne: (id) => api.get(`/api/questions/${id}`),
  create: (data) => api.post('/api/questions', data),
  update: (id, data) => api.put(`/api/questions/${id}`, data),
  delete: (id) => api.delete(`/api/questions/${id}`),
};


export const examsApi = {
  getAll: async () => {
    const res = await api.get("/api/exams");
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/api/exams/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/api/exams", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/api/exams/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/api/exams/${id}`);
    return res.data;
  },

  getQuestions: async (id) => {
    const res = await api.get(`/api/exams/${id}/questions`);
    return res.data;
  },

getSubjectsByGroup: async (group) => {
  console.log("REQUEST URL:", `/api/exams/subjects/${group}`);
  const res = await api.get(`/api/exams/subjects/${group}`);
  return res.data;
},
};
export const examQuestionsApi = {
  getAll: async () => {
    const res = await api.get("/api/examquestions");
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/api/examquestions/${id}`);
    return res.data;
  },

  getByExam: async (examId) => {
    const res = await api.get(`/api/examquestions/exam/${examId}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/api/examquestions", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/api/examquestions/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/api/examquestions/${id}`);
    return res.data;
  },
};

export default api;
